import { createStore } from "redux";
import { reducer } from "./reducer";

const appStore = createStore(reducer);

export default appStore;